<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text>
      <v-form
        ref="form"
        class="multi-col-validation mt-6"
      >
        <v-row>
          <v-col cols="12">
            <v-switch
              v-model="enabled"
              label="Окно технических работ включено"
              hide-details
              class="mt-0"
            ></v-switch>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="start"
              label="Начало (необязательно)"
              type="datetime-local"
              dense
              outlined
              clearable
              hint="Если не задано — окно активно сразу при включении"
              persistent-hint
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="end"
              label="Окончание (необязательно)"
              type="datetime-local"
              dense
              outlined
              clearable
              hint="Если задано — Retry-After считается до этого момента"
              persistent-hint
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="retryAfterSeconds"
              label="Retry-After по умолчанию (сек)"
              type="number"
              dense
              outlined
              :rules="[rules.required, rules.integerValidator]"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-textarea
              v-model="message"
              label="Сообщение пользователю"
              dense
              outlined
              rows="3"
              counter="1024"
              :rules="[rules.required]"
            ></v-textarea>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              class="me-3 mt-4"
              @click="saveData"
            >
              Сохранить
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="mt-4"
              type="reset"
              @click="cancel"
            >
              Отмена
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiCheck, mdiClose } from '@mdi/js'
import { mapActions } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import { rules } from '@/helpers/validation'

export default {
  name: 'MaintenanceSettingForm',
  data: () => ({
    icons: {
      mdiCheck,
      mdiClose,
    },
    rules,
  }),
  computed: {
    ...mapFormHandlers('maintenanceSettings', [
      'enabled',
      'start',
      'end',
      'retryAfterSeconds',
      'message',
    ]),
  },
  async created() {
    await this.fetch()
  },
  methods: {
    cancel() {
      this.$router.back()
    },
    ...mapActions('maintenanceSettings', ['update', 'fetch']),
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.update()
      }
    },
  },
}
</script>
